<template>
  <header
    class="mobile-chat-header"
    :class="{ 'safe-top': safeTop, 'is-sheet': sheet }"
  >
    <slot name="handle" />
    <div class="mobile-header-row">
      <button
        class="mobile-header-nav"
        type="button"
        :aria-label="$t('chatWorkbench.back')"
        @click="$emit('back')"
      >
        <ChatNavigationIcon name="back" />
      </button>
      <h1 :title="title"><span class="mobile-header-name">{{ title }}</span><slot name="title-badge" /></h1>
      <div v-if="$slots.actions" class="mobile-header-actions">
        <slot name="actions" />
      </div>
      <button
        class="mobile-header-nav"
        v-if="expandable"
        type="button"
        :aria-label="
          $t(
            expanded
              ? 'chatWorkbench.restoreSheet'
              : 'chatWorkbench.expandSheet'
          )
        "
        :aria-expanded="String(expanded)"
        @click="$emit('toggle-size')"
      >
        <ChatNavigationIcon :name="expanded ? 'restore' : 'expand'" />
      </button>
    </div>
  </header>
</template>
<script>
import ChatNavigationIcon from "./ChatNavigationIcon.vue";
export default {
  name: "MobileChatHeader",
  components: { ChatNavigationIcon },
  props: {
    title: String,
    safeTop: { type: Boolean, default: true },
    expandable: Boolean,
    expanded: Boolean,
    sheet: Boolean,
  },
};
</script>
<style lang="less" scoped>
.mobile-chat-header {
  --mobile-chat-safe-top: 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 0 0 auto;
  box-sizing: border-box;
  min-height: 68px;
  padding: 12px 12px 12px 8px;
  background: #fff;
  border-bottom: 1px solid #eef2f7;
  &.safe-top {
    --mobile-chat-safe-top: env(safe-area-inset-top, 0px);
    padding-top: calc(12px + env(safe-area-inset-top, 0px));
  }
  &.is-sheet {
    position: relative;
    min-height: calc(64px + var(--mobile-chat-safe-top));
    padding: calc(16px + var(--mobile-chat-safe-top)) 12px 4px 8px;
    transition: padding-top var(--sheet-motion-duration, 240ms)
        var(--sheet-motion-easing, cubic-bezier(0.2, 0.8, 0.2, 1)),
      min-height var(--sheet-motion-duration, 240ms)
        var(--sheet-motion-easing, cubic-bezier(0.2, 0.8, 0.2, 1));
  }
  .mobile-header-row {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 44px;
  }
  h1 {
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .mobile-header-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobile-header-actions {
    flex: 0 0 auto;
    max-width: 66%;
    min-width: 0;
  }
  .mobile-header-nav {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 44px;
    height: 44px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #475467;
    &:focus-visible {
      outline: 2px solid #4286f5;
      outline-offset: -2px;
      border-radius: 8px;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    &.is-sheet {
      transition: none;
    }
  }
}
</style>
